import { Box, Text } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

export const BreadCrumbsSkeleton: React.FC<{ numberOfSkeletons?: number }> = ({
  numberOfSkeletons,
}) => {
  return (
    <Box
      display="flex"
      width="full"
      flexDirection="row"
      alignItems="center"
      gap="small"
    >
      {Array.from({ length: numberOfSkeletons || 0 }).map((_, index) => (
        <>
          <Skeleton
            variant="text"
            width={90}
            height={30}
            backgroundColor="dark"
            data-id={`breadcrumbs-skeleton-${index}`}
          />
          <Text>{index < (numberOfSkeletons || 0) - 1 ? " / " : null}</Text>
        </>
      ))}
    </Box>
  );
};
